module.exports = __webpack_public_path__ + "fonts/RenaultLife-Regular.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Regular.svg
// module id = 346
// module chunks = 0